import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M28.12 25.78C28.12 25.78 13.7 25.67 11.28 19.5C8.87004 13.36 13.7 8.59998 18.88 8.59998C18.88 8.59998 21.19 1 28.24 1C35.29 1 36.5 6.60999 36.5 6.60999C36.5 6.60999 42.19 2.32004 46.19 5.29004C50.48 8.48004 47.73 13.88 47.73 13.88C47.73 13.88 54.61 14.19 53.45 20.27C52.13 27.21 36.72 24.45 36.28 27.1L28.12 25.78Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.7101 7.49996C47.7101 7.49996 35.49 6.28998 32.3 26.77"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M30.8701 1.89001C30.8701 1.89001 27.7901 9.70995 30.7601 24.5699"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M20.52 4.96997C20.52 4.96997 26.47 6.85997 28.01 25.34"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.2 13.3199C12.2 13.3199 21.4799 12.64 26.1899 23.88"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.8901 16.53C52.8901 16.53 44.7401 13.45 35.0601 25.12"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M42.064 23.3104C41.948 23.3778 41.8334 23.4467 41.7202 23.5171C41.8272 23.4447 41.9354 23.3753 42.0459 23.3095C42.201 23.2171 42.3576 23.1283 42.5155 23.0432C42.3638 23.13 42.2133 23.219 42.064 23.3104Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M22.2475 22.7852C22.3591 22.8687 22.4692 22.9546 22.5778 23.0425C22.66 23.1146 22.7412 23.1875 22.8211 23.2612C22.7415 23.1921 22.6614 23.1238 22.5806 23.0563L22.5795 23.0554C22.4697 22.9641 22.3591 22.8741 22.2475 22.7852Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M56.33 34.47C50.92 27.71 38.71 23.71 31.61 23.71C24.51 23.71 12.19 27.71 6.78 34.47C-2.91 46.58 3.69998 73.22 3.69998 73.22C3.69998 73.22 4.35998 51.64 11.63 45.26C17.82 39.82 23.5 41.91 31.56 41.91C39.62 41.91 45.3 39.83 51.49 45.26C58.76 51.65 59.42 73.22 59.42 73.22C59.42 73.22 66.02 46.58 56.33 34.47Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.9901 24.29C24.9901 24.29 22.5101 29.9 25.9801 41.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.3899 26.76C17.3899 26.76 13.43 33.04 16.4 42.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M13.92 28.58C13.92 28.58 8.64005 34.03 10.7801 45.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.44009 34.47C6.44009 34.47 0.880109 45.75 5.83011 57.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.1201 24.29C38.1201 24.29 40.6001 29.9 37.1301 41.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.7202 26.76C45.7202 26.76 49.6803 33.04 46.7103 42.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M49.1902 28.58C49.1902 28.58 54.4702 34.03 52.3302 45.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.6702 34.47C56.6702 34.47 62.2302 45.75 57.2802 57.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <mask id="path-18-inside-1" fill="white">
        <path d="M21.51 41.41C20.09 42.08 19.23 43.4 18.59 44.72C17.97 46.07 17.58 47.52 17.31 49C17.06 50.49 16.92 52 16.84 53.53L16.6699 58.15C16.4999 57.39 16.4 56.62 16.26 55.85C16.14 55.08 16.12 54.3 16.06 53.52C15.99 52.74 16.07 51.96 16.07 51.17C16.11 50.39 16.23 49.6099 16.33 48.8199C16.62 47.2699 17.0799 45.72 17.9099 44.34C18.2899 43.64 18.8399 43.02 19.4199 42.48C20.0399 41.99 20.73 41.53 21.51 41.41Z" />
      </mask>
      <path
        d="M21.51 41.41C20.09 42.08 19.23 43.4 18.59 44.72C17.97 46.07 17.58 47.52 17.31 49C17.06 50.49 16.92 52 16.84 53.53L16.6699 58.15C16.4999 57.39 16.4 56.62 16.26 55.85C16.14 55.08 16.12 54.3 16.06 53.52C15.99 52.74 16.07 51.96 16.07 51.17C16.11 50.39 16.23 49.6099 16.33 48.8199C16.62 47.2699 17.0799 45.72 17.9099 44.34C18.2899 43.64 18.8399 43.02 19.4199 42.48C20.0399 41.99 20.73 41.53 21.51 41.41Z"
        fill={outline}
      />
      <path
        d="M21.51 41.41L21.9367 42.3144L21.3579 40.4217L21.51 41.41ZM18.59 44.72L17.6902 44.2837L17.6856 44.2931L17.6812 44.3026L18.59 44.72ZM17.31 49L16.3262 48.8205L16.3249 48.8275L16.3237 48.8345L17.31 49ZM16.84 53.53L15.8414 53.4778L15.841 53.4855L15.8407 53.4932L16.84 53.53ZM16.6699 58.15L15.6941 58.3683L17.6693 58.1868L16.6699 58.15ZM16.26 55.85L15.2719 56.004L15.2738 56.0164L15.2761 56.0289L16.26 55.85ZM16.06 53.52L17.0571 53.4433L17.056 53.4306L16.06 53.52ZM16.07 51.17L15.0713 51.1188L15.07 51.1444V51.17H16.07ZM16.33 48.8199L15.347 48.636L15.3416 48.6651L15.3379 48.6944L16.33 48.8199ZM17.9099 44.34L18.7669 44.8554L18.7783 44.8365L18.7888 44.8171L17.9099 44.34ZM19.4199 42.48L18.7999 41.6954L18.7681 41.7205L18.7385 41.7481L19.4199 42.48ZM21.0833 40.5056C19.3418 41.3273 18.3547 42.9131 17.6902 44.2837L19.4898 45.1562C20.1053 43.8869 20.8382 42.8327 21.9367 42.3144L21.0833 40.5056ZM17.6812 44.3026C17.0152 45.7529 16.6054 47.2899 16.3262 48.8205L18.2937 49.1795C18.5545 47.7501 18.9248 46.3871 19.4987 45.1373L17.6812 44.3026ZM16.3237 48.8345C16.0657 50.3725 15.9227 51.9222 15.8414 53.4778L17.8386 53.5822C17.9173 52.0779 18.0542 50.6075 18.2962 49.1655L16.3237 48.8345ZM15.8407 53.4932L15.6706 58.1132L17.6693 58.1868L17.8393 53.5668L15.8407 53.4932ZM17.6458 57.9317C17.48 57.1904 17.3973 56.5151 17.2438 55.6711L15.2761 56.0289C15.4027 56.7249 15.5199 57.5897 15.6941 58.3683L17.6458 57.9317ZM17.248 55.696C17.1359 54.9766 17.1223 54.2921 17.057 53.4433L15.0629 53.5967C15.1176 54.308 15.144 55.1833 15.2719 56.004L17.248 55.696ZM17.056 53.4306C17.0263 53.1006 17.0274 52.7577 17.0383 52.3775C17.0487 52.0164 17.07 51.5835 17.07 51.17H15.07C15.07 51.5466 15.0512 51.8987 15.0391 52.32C15.0276 52.7224 15.0236 53.1595 15.064 53.6094L17.056 53.4306ZM17.0687 51.2213C17.1061 50.4905 17.2175 49.7719 17.3221 48.9455L15.3379 48.6944C15.2425 49.448 15.1138 50.2896 15.0713 51.1188L17.0687 51.2213ZM17.3129 49.0039C17.5912 47.5166 18.0215 46.0947 18.7669 44.8554L17.053 43.8246C16.1384 45.3452 15.6488 47.0233 15.347 48.636L17.3129 49.0039ZM18.7888 44.8171C19.0976 44.2482 19.5635 43.7127 20.1014 43.2119L18.7385 41.7481C18.1164 42.3273 17.4823 43.0317 17.0311 43.8629L18.7888 44.8171ZM20.04 43.2645C20.6415 42.7892 21.1567 42.4761 21.662 42.3984L21.3579 40.4217C20.3032 40.5839 19.4384 41.1908 18.7999 41.6954L20.04 43.2645Z"
        fill={outline}
        mask="url(#path-18-inside-1)"
      />
      <path
        d="M48.2599 52.62C48.3058 52.0361 48.2441 51.4522 48.1821 50.8655C48.1496 50.5579 48.1171 50.2495 48.0999 49.9399C48.0857 49.6205 48.011 49.3061 47.9367 48.9931C47.9063 48.8653 47.876 48.7376 47.8499 48.61L48.2599 52.62ZM48.2599 52.62C48.2476 52.8939 48.2428 53.1687 48.2381 53.4436C48.2278 54.0425 48.2175 54.6417 48.1288 55.2323L48.2599 52.62ZM47.0513 47.4644C47.1099 47.6219 47.1545 47.7877 47.196 47.9679C47.1498 47.7991 47.1016 47.631 47.0511 47.4639L47.0513 47.4644Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M52.4976 48.5964C52.5306 48.7844 52.5477 48.9664 52.5571 49.1515C52.5385 48.961 52.515 48.7712 52.4855 48.5823C52.4669 48.4234 52.4445 48.2648 52.4184 48.107C52.4483 48.2625 52.4736 48.4189 52.4944 48.5758L52.4958 48.5861L52.4976 48.5964Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M8.61702 53.4339C8.66051 53.0326 8.71721 52.632 8.78741 52.2334L8.62514 53.4179C8.61082 53.5108 8.59771 53.6042 8.58565 53.698C8.5949 53.6133 8.60494 53.5286 8.61584 53.4438L8.61594 53.4438L8.61702 53.4339Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M20.5702 45.2859C20.6336 45.1491 20.7013 45.0133 20.7734 44.8793C20.7029 45.0168 20.6364 45.1557 20.5738 45.2955L20.5696 45.3048L20.5658 45.3143C20.5104 45.4529 20.4565 45.5924 20.4042 45.7327C20.457 45.5833 20.5124 45.4343 20.5702 45.2859Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
